/**
 * FOR REFERENCES:
 * https://github.com/GannettDigital/traxex-server/blob/master/docs/qsp-fields.md#pixel-url-query-string-fields
 *
 * - %g': '', // Geolocation => `ct=US&st=IN&city=13341&dma=29&zp=46205&bw=4`
 * - %eadv!': '', // Advertiser
 * - %%ADUNIT%%': '', // Ad unit
 * - %%PATTERN:property%%': '', // Gannett site code
 * - %%PATTERN:contentid%%': '', // Presto asset content ID
 * - %%PATTERN:pageType%%': '', // Page content type
 * - %%PATTERN:ss%%': '', // Subscriber status
 * - %%PATTERN:ssts_section%%': '', // Content SSTS section value
 * - %%PATTERN:ssts_subsection%%': '', // Content SSTS subsection value
 * - %%PATTERN:ssts_topic%%': '', // Content SSTS topic value
 * - %%PATTERN:ssts_subtopic%%': '', // Content SSTS sub topic value
 *
 * // post-processed from GAM's geo `%g`
 * %%ZIP%% // zip code
 * %%CITY%% // city
 * %%STATE%% // state
 * %%COUNTRY%% // country
 */
import { __assign } from "tslib";
import { getAdContext } from 'shared/utils/adContext';
import { parseQueryString } from 'shared/utils/urls/misc';
/**
 * Get macros from url string
 */
export var getMacrosFromUrl = function (url) {
    var re = /%%([^%]+)%%|{{([^}]+)}}/g;
    var matches = url.matchAll(re);
    var matchArray = matches ? Array.from(matches) : [];
    return matchArray.map(function (match) { return ({
        macro: match[0],
        key: match[1],
    }); });
};
/**
 * Replace GAM's macros with passed values
 */
export var replaceUrlMacros = function (url) {
    var processedContext = getProcessedContext();
    var macros = getMacrosFromUrl(url);
    return macros.reduce(function (carrier, macroMatch) {
        // Ex: [%%SITE%%, SITE], [%%ZIP%% ZIP], [%%PATTERN:ss%%, PATTERN:ss]
        var macro = macroMatch.macro, key = macroMatch.key;
        // in processedContext, all keys are in lowercase
        var contextValue = processedContext[key.toLowerCase()];
        // should keep macro as is when there's no contextValue
        // So macro (ex: %%PATTERN:pageType%%) will be passed and processed by GAM (in Paramount Settings.txt case)
        return carrier.replace(macro, (contextValue !== null && contextValue !== void 0 ? contextValue : macro));
    }, url);
};
/**
 * Process and consolidate geolocation object with the rest of context
 * - reference: src/shared/types/window.d.ts -> Window.ADAPT.externalContext
 * - otherContext includes: `site`,..
 */
var getProcessedContext = function () {
    var context = getAdContext();
    return __assign(__assign({}, context), normalizeGeoContext(context));
};
/**
 * Normalize Geo. Currently only supports GAM.
 */
var normalizeGeoContext = function (context) {
    var dsp_name = context.dsp_name, geo = context.geo;
    if (dsp_name !== 'gam' || !geo) {
        return {};
    }
    var geoObject = parseQueryString(geo || '', true);
    var city = geoObject.city, country = geoObject.ct, state = geoObject.st, zip = geoObject.zp;
    return {
        city: city,
        country: country,
        state: state,
        zip: zip,
    };
};
